import React from "react";
import {
  View,
  StyleSheet,
  ViewStyle,
  StyleProp,
  ScrollView,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { spacing } from "~/styles/tokens";
import { useTheme } from "~/styles/theme";

interface ScreenProps {
  children: React.ReactNode;
  scroll?: boolean;
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  padded?: boolean;
}

export const Screen: React.FC<ScreenProps> = ({
  children,
  scroll = false,
  style,
  contentStyle,
  padded = true,
}) => {
  const { colors } = useTheme();
  const inner = (
    <View style={[styles.content, padded && styles.padded, contentStyle]}>
      {children}
    </View>
  );

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: colors.background }, style]}
      edges={["top", "left", "right"]}
    >
      {scroll ? (
        <ScrollView
          contentContainerStyle={styles.scroll}
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps="handled"
        >
          {inner}
        </ScrollView>
      ) : (
        inner
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
  padded: {
    paddingHorizontal: spacing.md,
  },
  scroll: {
    flexGrow: 1,
  },
});
